import React from 'react'
import './help.css';
import ButtonUp from '../../img/btn_up.svg';
import ButtonText from '../../img/btn_text.svg';
import ButtonDown from '../../img/btn_down.svg';

const HelpComponent = () => {
  return (
    <div className='help-container'>

      <div className='help-chunk'>
        <img className='info-img' alt='Upload Button' src={ButtonUp}></img>
        <h3>Upload Image</h3>
        Use this form to upload an image to Meme O Matic. You can choose an image on your device, a URL to an image, or just paste the image from the system clipboard.
      </div>

      <div className='help-chunk'>
        <img className='info-img' alt='Text Button' src={ButtonText}></img>
        <h3>Add Text</h3>
        Use this form to add text to your image. Every text element has a box (container) to control how the text fits on the screen. This box will break lines to fit.
        You can also choose the font, color and size. You can always change any of these attributes later on.
      </div>

      <div className='help-chunk'>
        <img className='info-img' alt='Download Button' src={ButtonDown}></img>
        <h3>Download Image</h3>
        Use this button to download your finished meme.        
      </div>

    </div>
  )
}

export default HelpComponent;